import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModalOverlay } from './ui';
import { EarlyPhysioOfferDialog } from './EarlyPhysioOfferDialog';
import { planHref, rememberChosenPlan, useAuth } from '../auth';

export function ChoosePlanCta({
  planId,
  className,
  children,
}: {
  planId: string;
  className?: string;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { me } = useAuth();

  const buyNow = () => {
    if (me?.role !== 'student') rememberChosenPlan(planId);
    setOpen(false);
    navigate(planHref(me, planId));
  };

  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)}>
        {children}
      </button>
      {open && (
        <ModalOverlay onBackdropClick={e => { if (e.target === e.currentTarget) setOpen(false); }}>
          <EarlyPhysioOfferDialog
            onBuy={buyNow}
            onRegister={!me ? () => {
              setOpen(false);
              navigate('/register');
            } : undefined}
            onDismiss={() => setOpen(false)}
          />
        </ModalOverlay>
      )}
    </>
  );
}
